import {Button, Col, Row, Tooltip} from "antd";
import {SubCompanyFilter} from "components/_defaultComponents/FilterComponents";
import React, {useEffect} from "react";
import {
    ActionButtonsRow,
    ExportButton,
    SubcompanyFilterContainer
} from "../CustomerHomePageWithShiftScore.styles";
import {useStore} from "hooks/useStore";
import {DownloadOutlined, FileExcelOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import ShiftScoreTable from "components/shiftScore/Components/ShiftScoreTable";
import moment from "moment";

const ActiveShifts = ({
    data,
    setData,
    loading,
    filters,
    setFilters,
    hasMultipleSubcompanies,
    currentPage,
    setCurrentPage,
    reloadData,
    setReloadData,
    reloadCount,
    setReloadCount,
    onSubCompanyChange,
    onStatusChange,
    showModal,
    isWaitingApproveActive
}) => {
    const stores = useStore();
    const {t} = useTranslation();

    useEffect(() => {
        if (isWaitingApproveActive) {
            setFilters(prev => ({
                ...prev,
                status: "waitingApprove",
                period: "",
                startDate: "",
                endDate: "",
                subCompany: ["all"]
            }));
        }
    }, [isWaitingApproveActive, setFilters]);

    return (
        <>
            <Row
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    marginBottom: !hasMultipleSubcompanies ? "15px" : "0"
                }}
            >
                <Row
                    gutter={{xs: 8, sm: 12, md: 16, lg: 24}}
                    style={{
                        flex: 2,
                        alignItems: "center",
                        padding: "0",
                        marginLeft: "0"
                    }}
                >
                    {/* Subcompany Filter - only show if user has multiple subcompanies */}
                    {hasMultipleSubcompanies && (
                        <SubcompanyFilterContainer>
                            <SubCompanyFilter
                                defaultValue={filters.subCompany}
                                value={filters.subCompany}
                                onChange={onSubCompanyChange}
                                company={stores?.meStore?.companies?.[0]?._id}
                                mode="multiple"
                                showAllOption={true}
                                allowClear={true}
                                disabled={false}
                                initialCall={true}
                            />
                        </SubcompanyFilterContainer>
                    )}
                </Row>
                <Row style={{flex: 1, justifyContent: "flex-end", marginRight: "0"}}>
                    <ActionButtonsRow>
                        <Tooltip
                            title={t("companyDetail.actions.exportWithExcel", {
                                ns: "companyDetail"
                            })}
                        >
                            <ExportButton
                                type="default"
                                data-testid="exportWithExcelButton"
                                onClick={async () => {
                                    const data = {...filters};
                                    const response = await stores.shiftStore.exportShiftScoreListByCurrentStatus(
                                        data
                                    );
                                    let link = document.createElement("a");
                                    link.href = response;
                                    link.download = `vardiya-durum-raporu-${moment().format(
                                        "YYYY-MM-DD-HH-mm-ss"
                                    )}.xlsx`;
                                    document.body.appendChild(link);
                                    link.click();
                                    setTimeout(function() {
                                        window.URL.revokeObjectURL(link);
                                    }, 200);
                                }}
                                icon={<DownloadOutlined />}
                                style={{
                                    marginRight: "0",
                                    color: "#000",
                                    fontWeight: "600",
                                    border: "1px solid #AEF001",
                                    borderRadius: "5px"
                                }}
                            />
                        </Tooltip>
                        {!stores.meStore.checkRole("isCompanyUser") && (
                            <Button onClick={showModal}>
                                {t("shiftScore.actions.addShiftScore", {
                                    ns: "shiftScore"
                                })}
                            </Button>
                        )}
                    </ActionButtonsRow>
                </Row>
            </Row>
            {/* Table */}

            <ShiftScoreTable
                loading={loading}
                data={data?.rows || []}
                setData={setData}
                dataCount={data?.dataCount}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                setReloadData={() => setReloadData(!reloadData)}
                setReloadCount={() => setReloadCount(!reloadCount)}
                filters={filters}
            />
        </>
    );
};

export default ActiveShifts;
